<script setup lang="ts">
import FancyModal from '@/js/vue/modal/fancy-modal.vue';
import { markRaw, ref } from 'vue';

type Modal = {
  key: string
  component: unknown
  props: Record<string, unknown>
  containerClass?: string
  onClose?: () => void
  title?: string
};

const modals = ref<Modal[]>([]);

function close(modal: Modal) {
  if (modal.onClose) {
    modal.onClose();
  }
  modals.value = modals.value.filter(item => item.key !== modal.key);
}

function add(
  component: unknown,
  props: Record<string, unknown> = {},
  settings: {
    onClose?: () => void
    containerClass?: string
    title?: string
  } = {},
) {
  modals.value.push({
    component: markRaw(component),
    props,
    key: `modal-${Math.random()}`,
    onClose: settings.onClose,
    containerClass: settings.containerClass,
    title: settings.title,
  });
}

defineExpose({ add });
</script>

<template>
  <div>
    <div v-for="modal in modals" :key="modal.key">
      <FancyModal
        :shown="true"
        :container-class="modal.containerClass"
        @close="close(modal)"
      >
        <template #heading>
          {{ modal.title }}
        </template>
        <template #default="{ close }">
          <component
            :is="modal.component"
            :key="modal.key"
            v-bind="modal.props"
            @close="close"
          />
        </template>
      </FancyModal>
    </div>
  </div>
</template>

<style scoped></style>
